
export default function isAudio(element) {
    let file = element.split('.')
    file = file[file.length-1].toLowerCase()
    return file === 'mp3';
}